import { z } from 'zod';
import { StageNoteSchema, StageSchema } from '../../model';

export const CreateStageNoteResponseSchema = z.object({
  result: z.object({
    success: z.boolean(),
    error: z.string().nullable(),
    entity: StageNoteSchema.nullable(),
  }),
});

export const CreateStageNoteVariablesSchema = z.object({
  input: z.object({
    parentType: z.string(),
    stageId: z.string().uuid(),
    parentId: z.string().uuid(),
    content: z.string().min(3).max(500),
  }),
});

export const CompleteStageResponseSchema = z.object({
  result: z.object({
    entity: z.object({
      completed: StageSchema,
      next: StageSchema.nullable(),
    }),
    success: z.boolean(),
    error: z.string().nullable(),
  }),
});

export const CompleteStageVariablesSchema = z.object({
  input: z.object({
    parentType: z.string(),
    parentId: z.string().uuid(),
    stageId: z.string().uuid(),
  }),
  parentType: z.string(),
  parentId: z.string().uuid(),
});
